import Vue from 'vue'
import { translationProcessing } from './translationProcessing'

export const setupTranslationService = () => {
  translationProcessing.init(({ value, notUpdate = false }) => {
    if (value) {
      const languages = window.config.language.available
      languages.forEach(lang => {
        Vue.i18n.add(lang, value.data[lang])
      })
    }
  })
}
